import { render, staticRenderFns } from "./ChromatographyFlexTableTitle.vue?vue&type=template&id=47bb3a0a&"
import script from "./ChromatographyFlexTableTitle.vue?vue&type=script&lang=js&"
export * from "./ChromatographyFlexTableTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports